import actions from './actions'
import mutations from './mutations'
import getters from './getters'

import Vuex from 'vuex'
import Vue from 'vue'

Vue.use(Vuex)

const state = {
  ramaisMonitor: [],
  callsOnWait: [],
  ramais: [],
  callsMonitorOperador: [],
  started: null,
  protocoloChamadas: [],
  history: [],
  endListAgent: false,
}

export default new Vuex.Store({
  state,
  mutations,
  actions,
  getters,
})
